<template>
    <modal @close="closeModal" dialog="modal-sm" class="dark-top">
        <div slot="title">
            <h2>
                <template v-if="!subscription.isSubcriptionActive">Activate Dynamic Pricing Add-on</template>
                <template v-else>Dynamic Pricing Add-on Activated</template>
            </h2>
        </div>
        <div slot="body">
            <div>
                <div class="d-flex flex-column p-4 fs-large">
                    <span class="mt-4">This add-on will apply a <strong>0.3% fee</strong> on the total value of
                        reservations.</span>

                    <template v-if="!subscription.isSubcriptionActive">
                        <span class="mt-4">
                            Please refer to the Payment Terms and Conditions for more information.
                        </span>
                        <span class="my-4">
                            Do you want to activate this add-on?
                        </span>
                    </template>

                    <template v-else>
                        <span class="mt-4">
                            By deactivating this feature, all existing rules groups and rules will be permanently
                            deleted.
                            You will also lose the ability to create new ones.
                        </span>
                        <span class="mt-4">If you deactivate this add-on, you will still be billed in the next invoice
                            cycle for the period in which it was active — from the last billing date until the day of
                            cancellation.</span>
                        <span class="my-4">
                            Please refer to the Payment Terms and Conditions for more information.
                        </span>
                    </template>
                </div>
            </div>
        </div>

        <div slot="footer" class="d-flex justify-content-between">
            <div class="d-flex justify-content-start pr1">
                <button type="button" class="btn action ml-0" @click="execute()"
                    v-show="this.subscription.isSubcriptionActive">
                    <i class="far fa-trash-alt fs-small mr-1"></i>
                    <span>Deactivate</span>
                </button>
            </div>

            <div class="d-flex justify-content-end pr1">
                <button type="button" class="btn cancel" @click="closeModal">Cancel</button>
                <button type="button" class="btn" @click="execute()" v-show="!this.subscription.isSubcriptionActive">
                    <span>Activate</span>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'

    export default {
        data() {
            return {}
        },
        beforeDestroy() {
            this.clearCardSubscription();
        },
        computed: {
            ...mapGetters([
                'getSelectedSubscription',
            ]),
            subscription() {
                return this.getSelectedSubscription;
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'closeAllModals',
                'clearCardSubscription',
                'enablePlugin',
                'disablePlugin',
                'donwloadSubscribedPlugins'
            ]),
            execute() {
                const pluginName = this.subscription.codeName;
                const isActive = this.subscription.isSubcriptionActive;

                const action = isActive ? this.disablePlugin : this.enablePlugin;
                const successMsg = isActive ? 'Successfully Deactivated' : 'Successfully Activated';

                action(pluginName)
                    .then(() => {
                        this.$toasted.success(successMsg, { duration: 2000 });
                    })
                    .catch(() => {
                        this.$toasted.error('An error occurred', { duration: 2000 });
                    })
                    .finally(() => {
                        this.donwloadSubscribedPlugins();
                    });

                this.closeAllModals();
            },
            closeWindow() {
                this.closeAllModals();
            },
        },
        components: {
            Modal
        }
    }
</script>



// WEBPACK FOOTER //
// Subscriptions.vue?0660a5ba